import { render, staticRenderFns } from "./performanceIndex.vue?vue&type=template&id=303b6c13&scoped=true"
import script from "./performanceIndex.vue?vue&type=script&lang=js"
export * from "./performanceIndex.vue?vue&type=script&lang=js"
import style0 from "./performanceIndex.vue?vue&type=style&index=0&id=303b6c13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303b6c13",
  null
  
)

export default component.exports